import * as React from 'react';

import { Button, Collapse, Stack, Typography } from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

interface NarrativeExpanderProps {
  narrative: string | null | undefined;
  cutoffWidth?: number;
}

function NarrativeExpander({ narrative, cutoffWidth = 256 }: NarrativeExpanderProps) {
  const [narrativeExpanded, setNarrativeExpanded] = React.useState<boolean>(false);

  const handleExpanderClick = () => setNarrativeExpanded((prev) => !prev);

  if (narrative === null || narrative === undefined || narrative.length <= cutoffWidth) {
    return (
      <Typography>{narrative}</Typography>
    );
  }

  return (
    <Stack direction="column" justifyContent="flex-start" alignItems="flex-start" spacing={0}>
      <Collapse collapsedSize={48} in={narrativeExpanded}>
        <Typography>{narrative}</Typography>
      </Collapse>
      <Button onClick={handleExpanderClick} startIcon={narrativeExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}>
        {narrativeExpanded ? 'Show Less' : 'Show More'}
      </Button>
    </Stack>
  );
}

export default NarrativeExpander;
